import { useTranslation } from "react-i18next"

import InfoTooltip from "../../../../../../Components/InfoTooltip/InfoTooltip"
import {
  EVIDENCE_DESCRIPTIONS,
  EVIDENCE_EXAMPLES,
  EVIDENCE_GUIDANCE
} from "../../schema/evidenceGuidance"
import ExampleTag from "./ExampleTag"
import GuidanceTag from "./GuidanceTag"

import styles from "./questionField.module.less"

// The Form.Item label: the question text plus whatever this particular question earns —
// a required marker, its own tooltip, and for an evidence-locker slot the Example and
// Guidance chips and the one-line "what this proves" subtext.
const QuestionLabel = ({ question }) => {
  const { t } = useTranslation()
  const example = EVIDENCE_EXAMPLES[question.key]
  const guide = EVIDENCE_GUIDANCE[question.key]
  const description = EVIDENCE_DESCRIPTIONS[question.key]

  return (
    <span className={styles.label}>
      <span className={styles.labelRow}>
        <span>{t(question.label)}</span>
        {question.required ? (
          <span className={styles.requiredTag} aria-label={t("Required")} title={t("Required")}>
            *
          </span>
        ) : null}
        {question.tooltip ? (
          <InfoTooltip className={styles.labelTip} title={t(question.tooltip)} />
        ) : null}
        {example ? <ExampleTag src={example} label={question.label} /> : null}
        {guide ? <GuidanceTag guide={guide} /> : null}
      </span>
      {description ? <span className={styles.labelDesc}>{t(description)}</span> : null}
    </span>
  )
}

export default QuestionLabel
